// Legacy WizCase's advScripts.js, kept while wizcase.com is split between that server and ours: both
// read these cookies on the shared parent domain to tell ExpressVPN a paid click from an organic one
// (see helpers\ImpactSharedId), whichever server the visitor lands on and whichever they click out from.
if (document.body.dataset.parentWebsiteId === 'wizcase') {
	const params = new URLSearchParams(window.location.search);
	const keys = [...params.keys()];
	const domain = '.' + window.location.hostname.split('.').slice(-2).join('.');

	const setCookie = (name, value, days) => {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(value)};path=/;expires=${expires};domain=${domain}`;
	};

	if (params.get('gclid')) {
		setCookie('gclid', params.get('gclid'), 30);
	}

	if (params.get('bc') === 'true') {
		setCookie('bc', 'true', 15);
	}

	//legacy matched "campaign" anywhere in the URL, so `utm_campaign` alone sets it too
	if (keys.some(key => key.includes('campaign'))) {
		setCookie('advParams', `ca${params.get('campaign') ?? ''}_ad${params.get('adgroup') ?? ''}_kw${params.get('keyword') ?? ''}`, 30);
	}

	if (keys.some(key => ['gclid', 'bc', 'yclid', 'msclkid', 'UTM_Source'].includes(key) || key.includes('campaign'))) {
		setCookie('FullAdvParams', window.location.search.substring(1), 30);
	}
}
